<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.13397 2.5C7.51888 1.83333 8.48112 1.83333 8.86603 2.5L14.1962 11.75C14.5811 12.4167 14.0999 13.25 13.3301 13.25H2.66987C1.90007 13.25 1.41895 12.4167 1.80385 11.75L7.13397 2.5ZM8 3L2.66987 12.25H13.3301L8 3ZM8 5.5C8.41421 5.5 8.75 5.83579 8.75 6.25V8.75C8.75 9.16421 8.41421 9.5 8 9.5C7.58579 9.5 7.25 9.16421 7.25 8.75V6.25C7.25 5.83579 7.58579 5.5 8 5.5ZM8 11.5C8.41421 11.5 8.75 11.1642 8.75 10.75C8.75 10.3358 8.41421 10 8 10C7.58579 10 7.25 10.3358 7.25 10.75C7.25 11.1642 7.58579 11.5 8 11.5Z"
    fill="currentColor"
  />
</svg>
